import { mapUserRole, UserRole } from '@taxora-shared-common/util';

export class User {
  constructor(
    private firstName: string,
    private lastName: string,
    private role: UserRole,
  ) {}

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  get roleTranslationKey(): string {
    return `common.userRoles.${mapUserRole(this.role)}`;
  }
}
